import * as React from "react";
import { useEffect, useState } from 'react';
import { CallClient, VideoDeviceInfo, AudioDeviceInfo, DeviceManager, RemoteParticipant } from '@azure/communication-calling';
import { Dropdown, DropdownProps, Text, Flex, MicOffIcon, CallVideoOffIcon, Button, CloseIcon, MicIcon } from '@fluentui/react-northstar';
import './custom-call-screen.scss';

interface ParticipantsProps {
    toggleParticipantsPanel: () => void;
    currentUserName: string;
    isAudioOn: boolean;
    remoteParticipants: RemoteParticipant[];
}

const Participants: React.FC<ParticipantsProps> = ({
    toggleParticipantsPanel,
    currentUserName,
    isAudioOn,
    remoteParticipants
}) => {
   
    return (
        <div className="participants-panel">
            <div className="participants-header">
                <h3>Participantes</h3>
                <Button
                    icon={<CloseIcon />}
                    text
                    className="close-panel-btn"
                    onClick={toggleParticipantsPanel}
                />
            </div>

            <ul className="participants-list">
                <li className="participant-item">
                    <span className="participant-name">{currentUserName} (Você)</span>
                    <span className="participant-icon">
                        {isAudioOn ? <MicIcon /> : <MicOffIcon />}
                    </span>
                </li>

                {remoteParticipants.length === 0 && (
                    <li className="participant-item muted">(Nenhum participante remoto visível ainda)</li>
                )}

                {remoteParticipants.map((participant, index) => (
                    <li className="participant-item" key={index}>
                        <span className="participant-name">
                            {participant.displayName || `Participante ${index + 1}`}
                        </span>
                        <span className="participant-icon">
                            {participant.isMuted ? <MicOffIcon /> : <MicIcon />}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Participants;
